/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import { doLog, hasValue } from "../../shared/utility";

import * as actions from "../../store/actions/index";
import classes from "../CrimeSubmission.css";
import Form from "../../components/UI/Form/Form";
import Grid from "@material-ui/core/Grid";
import LandingPage from "../../components/Navigation/LandingPage/LandingPage";
import Report from "./Report";
import Select from "react-select";

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
//   table: { "& .MuiTableCell-head": { fontWeight: 700 } },
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
// const quote = '"';
// const singleQuote = "'";
// const { rowHeight, headerHeight } = DEFAULT_GRID_OPTIONS;

class Reports extends Form {
  state = {
    searching: false,
    reportRunning: false,
    editMode: true,
    action: "",
    actionOption: null,
    //
    agencyOption: null,
    agencyEdit: false,
    agencyAdd: false,
    agencyORI: "",
    //
    reportSelection: null,
    // reportDefined: false
  };

  componentDidMount() {
    if (doLog()) console.log("[Reports] componentDidMount state:", this.state);
    if (doLog()) console.log("[Reports] componentDidMount props:", this.props);
    if (this.props.isAuthenticated) {
      if (this.props.webAgencyList === null) {
        const transactionType =
          '<CIDDB><QUERY TABLE="CitizenWebAgency" LIMIT="9999" OPERATORID="-1"><FIELD_LIST>ALL</FIELD_LIST></QUERY></CIDDB>';
        const data = {};
        const request = {
          transactionType,
          data,
        };
        this.setState({ searching: true });
        this.props.onRunTransaction(request, this.props.token, "webAgencyList");
      } else if (this.props.reportList === null) {
        this.props.onFetchReportList(this.props.token);
      }
    }
    this.checkForSpecificAgency();
  }

  componentDidUpdate() {
    // if (doLog()) console.log("[Reports] componentDidUpdate");
    if (doLog()) console.log("[Reports] componentDidUpdate state:", this.state);
    if (doLog()) console.log("[Reports] componentDidUpdate props:", this.props);
    if (
      this.state.searching &&
      this.props.error === null &&
      ((this.props.transDesc === "webAgencyList" &&
        hasValue(this.props.webAgencyList)) ||
        hasValue(this.props.result))
    ) {
      if (doLog()) console.log("[Reports] componentDidUpdate result:", this.props.result);
      if (doLog()) console.log("[Reports] componentDidUpdate transDesc:", this.props.transDesc);
      this.setState({ searching: false });
    } else if (this.props.reportList === null) {
      this.props.onFetchReportList(this.props.token);
    }
    this.checkForSpecificAgency();
  }

  checkForSpecificAgency() {
    if (
      hasValue(this.props.webAgencyList) &&
      !hasValue(this.state.agencyOption) &&
      this.props.modulePermissions &&
      this.props.modulePermissions.allowedAgencyCode !== "ALL"
    ) {
      let index = this.props.webAgencyList.findIndex((element) => {
        return (
          element.AGENCYCODE ===
          this.props.modulePermissions.allowedAgencyCode.toUpperCase()
        );
      });
      if (doLog()) console.log("[Reports] checkForSpecificAgency index:", index);
      const row = this.props.webAgencyList[index];
      if (doLog()) console.log("[Reports] checkForSpecificAgency row:", row);
      if (hasValue(row)) {
        const selectedAgency = {
          value: index,
          label: row.NAME,
        };
        this.setState({
          agencyOption: selectedAgency,
          agencyDisabled: true,
          agencyORI: row.ORI,
          agencyCode: this.props.modulePermissions.allowedAgencyCode,
        });
      }
    }
  }

  handleAgencyChange = (agencySelected) => {
    if (agencySelected.value === -1) {
      this.setState({
        agencyOption: null,
        agencyEdit: false,
        agencyAdd: true,
        agencyORI: "",
        agencyCode: null,
        action: "",
        actionOption: null,
      });
    } else {
      this.setState({
        agencyOption: agencySelected,
        agencyEdit: false,
        agencyAdd: false,
        agencyORI: this.props.webAgencyList[agencySelected.value].ORI,
        agencyCode: this.props.webAgencyList[agencySelected.value].AGENCYCODE,
        action: "",
        actionOption: null,
      });
    }
    if (doLog()) console.log(`[Reports] handleAgencyChange agencySelected:`, agencySelected);
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
  };

  handleReportSelection = (reportSelected) => {
    if (doLog()) console.log(`[Reports] handleReportSelection reportSelected:`, reportSelected);
    if (reportSelected.value === -1) {
      this.setState({ reportSelection: null, reportDefined: false });
    } else {
      this.setState({ reportSelection: reportSelected, reportDefined: false });
    }
    this.props.onClearReportResult();
  };

  render() {
    if (doLog()) console.log("[Reports] render props:", this.props);
    //-----------------------------------------------------------
    let agencyOptions = [];
    let agencyCodeOptions = [];
    if (this.props.webAgencyList !== null) {
      if (this.props.modulePermissions.allowedAgencyCode.toUpperCase() !== "ALL") {
        let index = this.props.webAgencyList.findIndex((element) => {
          return (
            element.AGENCYCODE ===
            this.props.modulePermissions.allowedAgencyCode.toUpperCase()
          );
        });
        if (doLog()) console.log("[Reports] render index:", index);
        const row = this.props.webAgencyList[index];
        agencyOptions.push({
          key: -1,
          value: row.ORI,
          label: row.NAME,
        });
        agencyCodeOptions.push({
          key: -1,
          value: row.AGENCYCODE.toLowerCase(),
          label: row.NAME,
        });
      } else {
        agencyOptions.push({ key: -1, value: "ALL", label: "ALL" });
        for (let i = 0; i < this.props.webAgencyList.length; i++) {
          const fields = this.props.webAgencyList[i];
          if (fields.NAME !== "Sample Data Only") {
            agencyOptions.push({
              key: i,
              value: fields.ORI,
              label: fields.NAME,
            });
            agencyCodeOptions.push({
              key: -1,
              value: fields.AGENCYCODE.toLowerCase(),
              label: fields.NAME,
            });
          }
        }
        if (doLog()) console.log(
          "[Reports] render webAgencyList length:",
          this.props.webAgencyList.length
        );
      }
      if (doLog()) console.log("[Reports] render agencyOptions:", agencyOptions);
      if (doLog()) console.log("[Reports] render agencyCodeOptions:", agencyCodeOptions);
    }

    let reportSection = null;
    let reportSelect = null;
    let reportOptions = [];

    if (hasValue(this.props.reportList)) {
      const reportElements = this.props.reportList;
      const reportCount = reportElements.length;
      if (doLog()) console.log("[Reports] render reportCount:", reportCount);
      for (let i = 0; i < reportCount; i++) {
        const element = reportElements[i];
        if (doLog()) console.log("[Reports] render element:", element);
        const label = element.getAttribute("label");
        if (doLog()) console.log("[Reports] render label:", label);
        reportOptions.push({ value: i, label: label });
      }
    }

    reportSelect = (
      <Grid container item>
        <Grid item xs={8}>
          <Select
            value={this.state.reportSelection}
            onChange={this.handleReportSelection}
            options={reportOptions}
            isSearchable="true"
          // isDisabled={this.state.agencyDisabled}
          />
        </Grid>
        <Grid item xs={4} />
      </Grid>
    );

    reportSection = (
      <Fragment>
        <p>Select a Report to Run:</p>
        {reportSelect}
      </Fragment>
    );

    let formSection = null;
    if (hasValue(this.state.reportSelection)) {
      if (doLog()) console.log("[ManageDB] render action value:", this.state.action.value);
      const ori = this.state.agencyORI;
      const index = this.state.reportSelection.value;
      const reportElements = this.props.reportList;
      formSection = (
        <Report
          key={index}
          reportDefinition={reportElements[index]}
          label={this.state.reportSelection.label}
          ori={ori}
          agencyOptions={agencyOptions}
          agencyCodeOptions={agencyCodeOptions}
        />
      );
    }

    let formHeader = (
      <Grid container item spacing={gridSpacing}>
        <Grid item xs={12} className={classes.FormHeader}>
          <p>Reports</p>
        </Grid>
        {/* {errorMessage} */}
      </Grid>
    );

    let formFields = (
      <Grid container item spacing={gridSpacing} className={classes.LongerCard}>
        <Grid item xs={12} className={classes.FormFields}>
          <Grid container item>
            {/* {agencySection} */}
            {reportSection}
            {formSection}
          </Grid>
        </Grid>
      </Grid>
    );

    //-----------------------------------------------------------
    return (
      <Fragment>
        <LandingPage />
        <div className={classes.CrimeSubmission}>
          <Grid container item spacing={gridSpacing}>
            {formHeader}
            {formFields}
          </Grid>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[Reports].mapStateToProps state:", state);
  return {
    loading: state.trans.loading,
    result: state.trans.result,
    transDesc: state.trans.transDesc,
    error: state.trans.error,
    authError: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    agencyCode: state.trans.agencyCode,
    modulePermissions: state.auth.modulePermissions,
    webAgencyList: state.trans.webAgencyList,
    reportList: state.trans.reportList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
    onFetchReportList: (token) => dispatch(actions.fetchReportList(token)),
    onClearReportResult: () => dispatch(actions.clearReportResult()),
    // onRunReport: (options, jsonResult, timeoutSecs, connectionName, token) =>
    //   dispatch(
    //     actions.runReport(
    //       options,
    //       jsonResult,
    //       timeoutSecs,
    //       connectionName,
    //       token
    //     )
    //   ),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(Reports)
// );
export default connect(mapStateToProps, mapDispatchToProps)(Reports);
